import "./css/spinner.css";

export const Spinner = () => {
    return (
        <div className="min-h-full text-content-color flex justify-center flex-wrap content-center">
            <div className="h-10 w-10 sm:h-14 sm:w-14">
                <div className="loader"></div>
            </div>
        </div>
    );
};
